<template>
  <div class="">
    <static-tabs-wallet active="policies"> </static-tabs-wallet>
    <policies> </policies>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Policies from "@/components/wallet/policies/index.vue";
import StaticTabsWallet from "@/components/wallet/static-tabs.vue";
export default {
  props: {},
  components: {
    Policies,
    StaticTabsWallet,
  },
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  created() {
    this.notifyQueue({
      text: "Portafoglio",
      path: "",
      level: 1,
    });
    this.notifyQueue({
      text: "Polizze",
      path: "insurance_policies.index",
      level: 2,
    });
  },
};
</script>
